import React from "react";
import { TrendingUp, TrendingDown, Sparkles } from "lucide-react";
import SignalDot from "./SignalDot";

export default function SetupCards({ results, onHover }) {
  const bullish = results.filter((r) => r.direction === "bullish").slice(0, 3);
  const bearish = results.filter((r) => r.direction === "bearish").slice(0, 3);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="setup-cards">
      <SetupCol title="Top Bullish" rows={bullish} variant="bull" onHover={onHover} />
      <SetupCol title="Top Bearish" rows={bearish} variant="bear" onHover={onHover} />
    </div>
  );
}

function SetupCol({ title, rows, variant, onHover }) {
  const isBull = variant === "bull";
  return (
    <div className="card-surface p-5 relative overflow-hidden glass-hover" data-testid={`setup-col-${variant}`}>
      <div className="absolute inset-0 pointer-events-none opacity-50"
        style={{ background: isBull
          ? "radial-gradient(circle at 90% 0%, rgba(0,255,156,0.18), transparent 50%)"
          : "radial-gradient(circle at 90% 0%, rgba(255,77,109,0.18), transparent 50%)" }} />
      <div className="relative">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            {isBull ? <TrendingUp className="w-4 h-4 text-[var(--bull)]" /> : <TrendingDown className="w-4 h-4 text-[var(--bear)]" />}
            <div>
              <div className="label-mono">{isBull ? "Long bias" : "Short bias"}</div>
              <h3 className="text-[15px] text-white font-semibold tracking-tight mt-0.5">{title}</h3>
            </div>
          </div>
          <div className={`signal-pill ${isBull ? "bull" : "bear"}`}><Sparkles className="w-3 h-3" /> {rows.length}</div>
        </div>
        <div className="space-y-2">
          {rows.length === 0 && <div className="text-white/40 text-xs label-mono py-4">No setups in range</div>}
          {rows.map((r) => (
            <div key={r.ticker}
              onMouseEnter={(e) => onHover && onHover(r.ticker, e.currentTarget.getBoundingClientRect())}
              onMouseLeave={() => onHover && onHover(null, null)}
              className="flex items-center justify-between px-3.5 py-3 rounded-xl bg-white/[0.025] border border-white/5 hover:border-white/15 hover:bg-white/[0.05] transition-all cursor-pointer"
              data-testid={`setup-${variant}-${r.ticker}`}>
              <div className="flex items-center gap-3">
                <SignalDot variant={variant} strength={r.strength} size={8} />
                <div>
                  <div className="font-semibold text-white text-[13px] tracking-tight">{r.ticker}</div>
                  <div className="font-mono text-[10px] text-white/40 mt-0.5">{r.timeframe.toUpperCase()} · {r.strength}</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <div className="font-mono text-[11px] text-white/60">RSI {r.indicators.rsi.toFixed(1)}</div>
                  <div className={`font-mono text-[11px] ${r.change_pct >= 0 ? "text-[var(--bull)]" : "text-[var(--bear)]"}`}>
                    {r.change_pct >= 0 ? "+" : ""}{r.change_pct.toFixed(2)}%
                  </div>
                </div>
                <div className={`font-semibold text-xl tabular-nums ${isBull ? "text-bull" : "text-bear"}`}>{r.score}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
